export const MODULES = {
  DEAL_TRACKER: 1,
};

export const INTEREST_RATE = 11;
